// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"22d74c46","284":"484f75cd"}[chunkId] + ".chunk.js";
};